import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";
import task02 from "./layouts/task-02/task";
import task03 from "./layouts/task-03/task";

const lesson: Lesson = {
  id: "cf4f643c-a995-4b4e-81c3-e644e3cc910a",
  publicId: "14",
  name: "Directive microphones",
  difficulty: 3,
  contentTypes: { audio: true, interactive: true, video: false },
  body: [principle01, task01, task02, task03],
};

export default lesson;
